<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (extensionGroup of extensionGroups | async; track trackBy(extensionGroup)) {
      <lcs-option [value]="extensionGroup" id="lcs-option-id-{{ extensionGroup.extensionGroupId }}">
         {{ extensionGroup.name }}
      </lcs-option>
      }
   </div>
</ng-template>
